/* eslint-disable no-param-reassign,consistent-return */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { message, Modal } from "antd";
import rtkRequestStatusCodes from "../../lib/const/rtkRequestStatusCodes";
import {
  createAgreementByAccId,
  deleteAgreementVersionsRoute,
  getAgreementByAgrId,
  getAgreementsByAccIdRoute,
  getAgreementVersions,
  updateAgreementVersionsRoute,
} from "../../lib/routes/accounts";
import Message from "../../components/Message/Message";

const initialState = {
  agreement: null,
  agreements: [],
  agreementsVersions: "",
  agreementsLoading: rtkRequestStatusCodes.idle,
  agreementLoading: rtkRequestStatusCodes.idle,
  agreementsVersionsLoading: rtkRequestStatusCodes.idle,
  createAgreementLoading: rtkRequestStatusCodes.idle,
};

const fetchGetAgreementsByAccId = createAsyncThunk(
  "agreements/fetchAgreementById",
  async ({ accId }) => {
    try {
      const response = axios.get(getAgreementsByAccIdRoute(accId));
      const { data } = await response;
      return data;
    } catch (e) {
      Message("Ошибка загрузки данных. Попробуйте позже", e);
    }
  }
);

const fetchAgreementByAgrId = createAsyncThunk(
  "agreements/fetchAgreementByAgrId",
  async ({ agreementId }) => {
    try {
      const url = getAgreementByAgrId(agreementId);
      const { data } = await axios(url);
      return data;
    } catch (e) {
      Message("Ошибка загрузки данных. Попробуйте позже", e);
    }
  }
);

const clearAgreement = createAsyncThunk("agreements/clearAgreements", () => null);

const fetchAgreementVersions = createAsyncThunk(
  "agreements/fetchAgreementVersions",
  async ({ agreementId }) => {
    try {
      const url = getAgreementVersions(agreementId);
      const { data } = await axios(url);
      return data.sort((a, b) => new Date(b.toDate) - new Date(a.toDate));
    } catch (e) {
      Message("Ошибка загрузки данных. Попробуйте позже", e);
    }
  }
);

const createAgreement = createAsyncThunk("agreements/createAgreement", async (dataPost) => {
  const { accountId, values } = dataPost;
  try {
    message.loading("Сохранение", 0);
    const response = axios.post(createAgreementByAccId(accountId), values);
    const { data } = await response;
    message.destroy();
    message.success("Договор успешно создан");
    return data;
  } catch (e) {
    message.destroy();
    message.error("Ошибка создания");
  }
});

const updateAgreementVersions = createAsyncThunk(
  "agreements/updateAgreementVersions",
  async ({ id, fromDate, force, values }) => {
    try {
      message.loading("Сохранение", 0);
      const response = axios.patch(updateAgreementVersionsRoute(id, fromDate, force), values);
      const { data } = await response;
      message.destroy();
      if (force === true) {
        message.success("Версия успешно обновлёна");
      } else {
        message.success("Версия успешно добавлена");
      }
      return data;
    } catch (e) {
      message.destroy();
      if (force === true) {
        message.error("Ошибка обновления");
      } else {
        message.error("Ошибка добавления");
      }
    }
  }
);

const deleteAgreementVersion = createAsyncThunk(
  "agreements/deleteProfilesVersion",
  // eslint-disable-next-line consistent-return
  async (id, fromDate) => {
    try {
      message.loading("Изменение даты", 0);
      const response = axios.delete(deleteAgreementVersionsRoute(id, fromDate));
      const { data } = await response;
      message.destroy();
      message.success("Дата успешно обновлёна");
      return data;
    } catch (e) {
      message.destroy();
      Modal.error({
        title: "Ошибка",
        content: `${e.response.data.message}`,
      });
      /* message.error(`Ошибка изменения - ${e.response.data.message}`); */
    }
  }
);

export const agreementsSlice = createSlice({
  name: "agreements",
  initialState,
  reducers: {
    resetAgreementsCreateLoading: (state) => {
      state.createAgreementLoading = rtkRequestStatusCodes.idle;
    },
  },
  extraReducers: {
    [clearAgreement.fulfilled]: (state) => {
      state.agreement = [];
      state.agreementLoading = rtkRequestStatusCodes.idle;
    },
    [createAgreement.fulfilled]: (state) => {
      state.createAgreementLoading = rtkRequestStatusCodes.fulfilled;
    },
    [createAgreement.rejected]: (state) => {
      state.createAgreementLoading = rtkRequestStatusCodes.rejected;
    },
    [fetchGetAgreementsByAccId.fulfilled]: (state, action) => {
      state.agreements = action.payload;
      state.agreementsLoading = rtkRequestStatusCodes.fulfilled;
    },
    [fetchGetAgreementsByAccId.pending]: (state) => {
      state.agreementsLoading = rtkRequestStatusCodes.pending;
    },
    [fetchGetAgreementsByAccId.rejected]: (state) => {
      state.agreementsLoading = rtkRequestStatusCodes.rejected;
    },
    [fetchAgreementByAgrId.fulfilled]: (state, action) => {
      state.agreement = action.payload;
      state.agreementLoading = rtkRequestStatusCodes.fulfilled;
    },
    [fetchAgreementByAgrId.pending]: (state) => {
      state.agreementLoading = rtkRequestStatusCodes.pending;
    },
    [fetchAgreementByAgrId.rejected]: (state) => {
      state.agreementLoading = rtkRequestStatusCodes.rejected;
    },
    [fetchAgreementVersions.fulfilled]: (state, action) => {
      state.agreementsVersions = action.payload;
      state.agreementsVersionsLoading = rtkRequestStatusCodes.fulfilled;
    },
    [fetchAgreementVersions.pending]: (state) => {
      state.agreementsVersionsLoading = rtkRequestStatusCodes.pending;
    },
    [fetchAgreementVersions.rejected]: (state) => {
      state.agreementsVersionsLoading = rtkRequestStatusCodes.pending;
    },
  },
});

const { reducer, actions: agreementsSliceActions } = agreementsSlice;

export {
  agreementsSliceActions,
  fetchGetAgreementsByAccId,
  fetchAgreementByAgrId,
  fetchAgreementVersions,
  createAgreement,
  updateAgreementVersions,
  deleteAgreementVersion,
  clearAgreement,
  reducer,
};
